function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var themeColors = {
  // Basic
  white: '#FFFFFF',
  black: '#000000',
  // Spring
  spring_normal: '#29A160',
  spring_dark: '#20804C',
  spring_light: '#94D0AF',
  spring_lighter: '#E9F5EF',
  // Sea
  sea_normal: '#2E6BFF',
  sea_dark: '#2455CC',
  sea_light: '#96B5FF',
  sea_lighter: '#EAF0FF',
  // Sunset
  sunset_normal: '#FF8A65',
  sunset_dark: '#E77652',
  sunset_light: '#FFC4B2',
  sunset_lighter: '#FFDBD0',
  // Mars
  mars_normal: '#F5A623',
  mars_dark: '#E69C21',
  mars_light: '#FAD291',
  mars_lighter: '#FEF6E9',
  // Wine
  wine_normal: '#D13649',
  wine_dark: '#B32E3F',
  wine_light: '#E89AA4',
  wine_lighter: '#F9EAEA',
  // re
  re_normal: '#3AA4FF',
  re_dark: '#3493E5',
  re_light: 'rgba(58, 164, 255, 0.4)',
  re_lighter: '#EBF5FF',
  // vehicules
  vehicules_normal: '#FF4C59',
  vehicules_dark: '#E5444F',
  vehicules_light: '#FFA6AC',
  vehicules_lighter: '#FFDBDE',
  // market
  market_normal: '#2EC966',
  market_dark: '#29B45B',
  market_light: '#ABE9C2',
  market_lighter: '#EAF9EF',
  // jobs
  jobs_normal: '#35B5A4',
  jobs_dark: '#2FA293',
  jobs_light: '#9ADAD1',
  jobs_lighter: '#EAF7F5',
  // nc
  nc_normal: '#8871FF',
  nc_dark: '#7A65E5',
  nc_light: '#C3B8FF',
  nc_lighter: '#F3F0FF',
  // shops
  shops_normal: '#FC942D',
  shops_dark: '#E28428',
  shops_light: '#FDC996',
  shops_lighter: '#FEEAD5',
  // Midnight
  midnight_normal: '#2D2D2D',
  midnight_light: '#4A4A4A',
  midnight_lighter: '#666666',
  // Smoke
  smoke_normal: '#9B9B9B',
  smoke_light: '#D0D0D0',
  smoke_lighter: '#F2F2F2',
  // Auto neuf
  autoNeuf_normal: '#993C77',
  autoNeuf_dark: '#89356A',
  autoNeuf_light: '#CC9DBB',
  autoNeuf_lighter: '#EBD8E4'
};
export var colorsNames = ['primary', 'secondary', 'spring', 'sea', 'wine', 'mars', 'sunset'];
var colors = _objectSpread(_objectSpread({}, themeColors), {}, {
  // Primary
  primary: themeColors.spring_normal,
  primary_normal: themeColors.spring_normal,
  primary_dark: themeColors.spring_dark,
  primary_light: themeColors.spring_light,
  primary_lighter: themeColors.spring_lighter,
  // Secondary
  secondary: themeColors.sea_normal,
  secondary_normal: themeColors.sea_normal,
  secondary_dark: themeColors.sea_dark,
  secondary_light: themeColors.sea_light,
  secondary_lighter: themeColors.sea_lighter
});
export default colors;